var FilterApprovalsEquipmentsModule = /** @class */ (function () {
    function FilterApprovalsEquipmentsModule() {
    }
    return FilterApprovalsEquipmentsModule;
}());
export { FilterApprovalsEquipmentsModule };
